import {Modal, Input, Row, Col} from "antd";
import {useState} from 'react';
import {UserSelectWidget} from "../tasks/UserSelectWidget";
import {DatePickerWidget} from "../widget/DatePickerWidget";
import * as dayjs from "dayjs";

const {TextArea} = Input;

export const HarvestModal = ({open, user, onOk, onCancel, count, props}) => {

    const [notes, setNotes] = useState(undefined);
    const [createdBy, setCreatedBy] = useState (user);

    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const [displayDate, setDisplayDate] = useState(dayjs(new Date()).toString());

    const onModalOk = () => {
        if (onOk) {
            onOk(notes, createdBy, displayDate);
        }
        clearForm();
    }

    const onModalCancel = () => {
        if (onCancel) onCancel();
        clearForm();
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const setUser = (val) => {
        setCreatedBy(val);
    }

    const onDueDateChange = (dateString, dateJs) => {
        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayDate(dateJsString);
    }

    const clearForm = () => {
        setNotes(undefined);
        setCreatedBy(user);
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const colStyle = {
        marginRight: '5px',
        marginLeft: '5px',
    }

    return <Modal title={<b>Harvest Plants</b>} open={open} onOk={onModalOk} onCancel={onModalCancel}>
        <Row style={rowStyle}>{count} Plants will be Harvested</Row>
        <Row style={rowStyle}>Check the Harvest Tab to Enter the Weights Trimmed.</Row>
        <Row style={rowStyle}>
            <Col span={6}>
                <b>Performed By:</b>
            </Col>
            <Col>
                <UserSelectWidget user={createdBy} setUser={setUser} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={5} style={{...colStyle, paddingTop: '4px'}}><b>Select Date:</b></Col>
            <Col style={colStyle}>
                <DatePickerWidget date={displayDate} onChange={onDueDateChange} placeholder={'Metric Date'} maxDate={new Date()}/>
            </Col>
        </Row>
        <TextArea maxLength={512} rows={4} onChange={onNotesChange} placeholder={'Notes'} />
    </Modal>
}